import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { UpdateEmailActions } from './updateEmailActions';
import {
    IUpdateEmailFormDispatchProps,
    IUpdateEmailFormStateProps,
    UpdateEmailForm,
} from './UpdateEmailForm';
import AccountSecurityActions from '../accountSecurityActions';
import { AccountSecurityFormType } from '../AccountSecurity';
import { AnyAction } from 'redux';
import { setVerifyingEmail, validatePassword } from '../verifyEmail/verifyEmailFormActions';
import { VerifyEmailActionTypes } from '../verifyEmail/verifyEmailActionTypes';
import { ISendEmailOtpPayload } from '../verifyEmail/verifyEmailRequest';
import { RevokeSessionActions } from '../revokeSession/revokeSessionActions';

function mapStateToProps(state: IReduxRootState) {
    const {
        app: {
            locale,
            presentationConfig: {
                visibleFields: { account },
            },
            clientConfig: { emailVerificationFAQUrls, supportPageUrl },
        },
    } = state;

    const updateEmailValidatorRules = account.updateEmail.validatorRules;
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.EMAIL_VERIFICATION
            : '',
        clientId: state.app.clientConfig ? state.app.clientConfig.clientId : undefined,
        isSubmitting: state.accountSecurity.updatingEmail,
        member: state.member,
        updateEmailValidatorRules: updateEmailValidatorRules,
        passwordValid: state.accountSecurity.passwordValid,
        locale,
        emailVerificationFAQUrls,
        supportPageUrl,
        sessionRevocationEnabled: state.app.appConfig.SESSION_REVOCATION_ENABLED ?? true, // Enabled by-default
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>) {
    return {
        updateEmail: (data: any) => {
            dispatch(UpdateEmailActions.updateMemberEmail(data));
        },
        closeAccountSecurityOverlay: () =>
            dispatch(AccountSecurityActions.closeAccountSecurityOverlay()),
        changeAccountSecurityOverlay: (content: AccountSecurityFormType | undefined) =>
            dispatch(AccountSecurityActions.changeAccountSecurityOverlay(content)),
        setVerifyingEmail: (email: string) => {
            dispatch(setVerifyingEmail(email));
        },
        validatePassword: (payload: ISendEmailOtpPayload) => {
            dispatch(validatePassword(payload));
        },
        setPasswordValidFalse: () => {
            dispatch({
                type: VerifyEmailActionTypes.SET_PASSWORD_VALID_FALSE,
            });
        },
        setVerifyEmailFromUpdateEmail: () => {
            dispatch({
                type: VerifyEmailActionTypes.SET_VARIFY_EMAIL_FROM_UPDATE_EMAIL,
            });
        },
        setSessionRevoke: (signOutFromAllDevices: boolean) => {
            dispatch(RevokeSessionActions.setSessionRevoke(signOutFromAllDevices));
        },
    };
}

const UpdateEmailFormContainer = connect<
    IUpdateEmailFormStateProps,
    IUpdateEmailFormDispatchProps,
    {},
    IReduxRootState
>(
    mapStateToProps,
    mapDispatchToProps,
)(UpdateEmailForm);

export default UpdateEmailFormContainer;
